import { EditOutlined } from '@ant-design/icons';
import { ButtonProps } from 'antd/es/button';
import { AntButton } from 'components/ant/AntButton/AntButton';
import React from 'react';

interface Props extends ButtonProps {
  compact?: boolean;
}

export const EditButton: React.FC<Props> = (props) => {
  const { compact, children, ...rest } = props;

  return (
    <AntButton icon={<EditOutlined />} type="link" size="small" {...rest}>
      {children ? children : compact ? '' : 'Edit'}
    </AntButton>
  );
};
